var map = {
	"./al-midrar": 16022,
	"./al-midrar.js": 16022,
	"./anees_hussain": 59387,
	"./anees_hussain.js": 59387,
	"./astc": 24908,
	"./astc.js": 24908,
	"./default": 15566,
	"./default.js": 15566,
	"./edcentra": 35588,
	"./edcentra.js": 35588,
	"./saylani": 74297,
	"./saylani.js": 74297
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35102;